import React from 'react';
import '../../App.css';

import Footer from '../Footer';
import News from '../News';

function NewsSection() {
  return (
    <>
      <News />
      <Footer />
    </>
  );
}

export default NewsSection;
